// ─────────────────────────────────────────────────────────────
// src/pages/TaxCalculator/components/IndividualForm.jsx
// Salary input form for the individual-calculator mode.
// Pure UI – all logic lives in useIndividualCalculator hook.
// ─────────────────────────────────────────────────────────────

import React from "react";
import {
  Shield,
  DollarSign,
  AlertCircle,
  Calculator,
  RefreshCw,
} from "lucide-react";

const IndividualForm = ({
  calculationMode,
  inputs,
  errors,
  onInputChange,
  onCalculate,
  onReset,
  styles,
  t,
}) => (
  <div style={styles.card}>
    {/* Insurance salary – always required */}
    <div style={styles.inputGroup}>
      <label style={styles.label}>
        <Shield size={18} />
        {t.insuranceSalaryRequired}
      </label>
      <input
        type="number"
        placeholder={t.enterInsuranceSalary}
        value={inputs.insurance}
        onChange={(e) => onInputChange("insurance", e.target.value)}
        style={styles.input(errors.insurance)}
      />
      {errors.insurance && (
        <div style={styles.error}>
          <AlertCircle size={14} />
          {errors.insurance}
        </div>
      )}
    </div>

    {/* Gross or Net salary depending on mode */}
    {calculationMode === "netFromGross" ? (
      <div style={styles.inputGroup}>
        <label style={styles.label}>
          <DollarSign size={18} />
          {t.grossSalary}
        </label>
        <input
          type="number"
          placeholder={t.enterGrossSalary}
          value={inputs.gross}
          onChange={(e) => onInputChange("gross", e.target.value)}
          style={styles.input(errors.gross)}
        />
        {errors.gross && (
          <div style={styles.error}>
            <AlertCircle size={14} />
            {errors.gross}
          </div>
        )}
      </div>
    ) : (
      <div style={styles.inputGroup}>
        <label style={styles.label}>
          <DollarSign size={18} />
          {t.netSalary}
        </label>
        <input
          type="number"
          placeholder={t.enterNetSalary}
          value={inputs.net}
          onChange={(e) => onInputChange("net", e.target.value)}
          style={styles.input(errors.net)}
        />
        {errors.net && (
          <div style={styles.error}>
            <AlertCircle size={14} />
            {errors.net}
          </div>
        )}
      </div>
    )}

    <div style={styles.buttonGroup}>
      <button style={styles.button("primary")} onClick={onCalculate}>
        <Calculator size={20} />
        {t.calculateNow}
      </button>
      <button style={styles.button("secondary")} onClick={onReset}>
        <RefreshCw size={20} />
        {t.reset}
      </button>
    </div>
  </div>
);

export default IndividualForm;